// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, serverTimestamp } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// HARDCODED CONFIG - Direct connection to Sunday League Database
const firebaseConfig = {
  apiKey: "AIzaSyCe2jy2RhEoAG4abQezefYNrczIum7ch4E",
  authDomain: "bowling-tracker-f5cd5.firebaseapp.com",
  projectId: "bowling-tracker-f5cd5",
  storageBucket: "bowling-tracker-f5cd5.firebasestorage.app",
  messagingSenderId: "59162132207",
  appId: "1:59162132207:web:f02a22a50d8c031c74a51a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Exporting references for the app to use
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider(); // For Google Login
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const timestamp = serverTimestamp;

export default app;